module.exports = __webpack_public_path__ + "static/media/gb2.545e3621.png";